module.exports = __webpack_public_path__ + "static/media/full-spa-body-massage-and-luluran.1f6ce5f2.webp";